import { ca } from '@cian/analytics';

export function trackSortClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingAgents',
    action: 'Click',
    label: 'Sort',
  });
}
